export async function createRecord(collection, payload) {
    let response = await fetch(`/api/${collection}`, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "authorization": localStorage.getItem("token")
        },
        body: JSON.stringify(payload)
    })
    return await response.json()
}
export async function createMultipatDataRecord(collection, payload) {
    let response = await fetch(`/api/${collection}`, {
        method: "POST",
        headers: {
            "authorization": localStorage.getItem("token")
        },
        body: payload
    })
    return await response.json()
}

export async function getRecord(collection, payload) {
    let url = ""
    if (collection === "cart" || collection === "wishlist")
        url = `/api/${collection}/${localStorage.getItem("userid")}`
    else if (collection === "checkout") {
        if (localStorage.getItem("role") === "Buyer")
            url = `/api/${collection}/user/${localStorage.getItem("userid")}`
        else
            url = `/api/${collection}`
    }
    else
        url = `/api/${collection}`

    let response = await fetch(url, {
        method: "GET",
        headers: {
            "content-type": "application/json",
            "authorization": localStorage.getItem("token")
        }
    })
    return await response.json()
}


export async function updateRecord(collection, payload) {
    let response = await fetch(`/api/${collection}/${payload._id}`, {
        method: "PUT",
        headers: {
            "content-type": "application/json",
            "authorization": localStorage.getItem("token")
        },
        body: JSON.stringify(payload)
    })
    return await response.json()
}

export async function updateMultipatDataRecord(collection, payload) {
    let response = await fetch(`/api/${collection}/${payload.get('_id')}`, {
        method: "PUT",
        headers: {
            "authorization": localStorage.getItem("token")
        },
        body: payload
    })
    return await response.json()
}


export async function deleteRecord(collection, payload) {
    let response = await fetch(`/api/${collection}/${payload._id}`, {
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            "authorization": localStorage.getItem("token")
        }
    })
    return await response.json()
}